import { useState } from "react";
import { Video, ClipboardList, ExternalLink, Menu, X, Egg } from "lucide-react";
import VideosTab from "@/components/admin/VideosTab";
import SeminarDetailsTab from "@/components/admin/SeminarDetailsTab";

const TABS = [
    { id: "videos", label: "Video Management", Icon: Video, C: VideosTab },
    { id: "seminar", label: "Seminar Details", Icon: ClipboardList, C: SeminarDetailsTab },
];

export default function AdminDashboard() {
    const [tab, setTab] = useState("videos");
    const [open, setOpen] = useState(false);

    const Current = TABS.find((t) => t.id === tab)?.C;

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="admin-dashboard">
            <header className="sticky top-0 z-20 bg-blue-700 text-white shadow-md">
                <div className="max-w-[1400px] mx-auto flex items-center justify-between px-4 py-3">
                    <div className="flex items-center gap-3">
                        <button
                            className="lg:hidden p-2 -ml-2 hover:bg-white/10 rounded-lg"
                            onClick={() => setOpen(!open)}
                            data-testid="sidebar-toggle"
                        >
                            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                        </button>
                        <div className="w-9 h-9 rounded-xl bg-white/15 flex items-center justify-center">
                            <Egg className="w-5 h-5" />
                        </div>
                        <div className="leading-tight">
                            <div className="font-semibold text-base">Energy Plus CMS</div>
                            <div className="text-[11px] uppercase tracking-widest text-white/70">Admin Panel</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <a
                            href="/"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm px-3 py-2"
                            data-testid="view-site"
                        >
                            <ExternalLink className="w-4 h-4" /> View site
                        </a>
                    </div>
                </div>
            </header>

            <div className="max-w-[1400px] mx-auto flex">
                <aside className={`fixed lg:static inset-y-14 left-0 z-10 lg:z-0 w-72 lg:w-64 bg-white border-r border-slate-200 lg:border-r-0 transform transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
                    <div className="p-4 space-y-1">
                        {TABS.map(({ id, label, Icon }) => {
                            const active = tab === id;
                            return (
                                <button
                                    key={id}
                                    onClick={() => { setTab(id); setOpen(false); }}
                                    data-testid={`tab-${id}`}
                                    className={`w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition-all ${active ? "bg-blue-50 text-blue-700 font-semibold" : "text-slate-600 hover:bg-slate-50"}`}
                                >
                                    <Icon className={`w-4 h-4 ${active ? "text-blue-600" : "text-slate-400"}`} />
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    <div className="p-4 mt-2 border-t border-slate-100">
                        <div className="text-[11px] uppercase tracking-widest text-slate-400 mb-2">Quick Links</div>
                        <a href="/" target="_blank" rel="noreferrer" className="block text-sm text-slate-600 hover:text-blue-600 py-1">Public landing page ↗</a>
                    </div>
                    <div className="p-4 border-t border-slate-100">
                        <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-3 text-xs text-emerald-800">
                            <div className="font-bold mb-1">✅ Live Sync</div>
                            <div>Save केल्यावर landing page वर लगेच update होते — redeploy लागत नाही.</div>
                        </div>
                    </div>
                </aside>
                {open && <div onClick={() => setOpen(false)} className="lg:hidden fixed inset-0 bg-black/30 z-0" />}

                <main className="flex-1 min-w-0 p-6">
                    {Current ? <Current /> : null}
                </main>
            </div>
        </div>
    );
}
